import type { TodayStats, TodayStatsResponse } from '../../../../shared/types/stats';
import type { ErrorResponse } from '../../../../shared/types/epics';
import { authFetch } from './authFetch';
import { API_BASE } from './version';

/**
 * Fetch today's aggregate stats for the dashboard StatsBadge.
 *
 * Auth: authFetch handles bearer + refresh + logout-on-expiry.
 * Errors: throws Error with the backend-supplied message so TanStack Query
 * can render the "stats unavailable" chip.
 */
export async function fetchStatsToday(): Promise<TodayStats> {
  const response = await authFetch(`${API_BASE}/stats/today`, { method: 'GET' });

  if (!response.ok) {
    let message = `Failed to fetch stats: ${response.statusText}`;
    try {
      const errorBody = (await response.json()) as ErrorResponse;
      if (errorBody?.error?.message) {
        message = errorBody.error.message;
      }
    } catch {
      /* response wasn't JSON */
    }
    throw new Error(message);
  }

  const body = (await response.json()) as TodayStatsResponse;
  return body.data;
}
